import AlertTriangle from 'blaze-ui/icons/20/AlertTriangle'
import Styles from './Notice.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import cx from 'classnames'

interface NoticeProps {
  message: React.ReactNode
  variant?: 'warning' | 'danger'
  title?: string
  children?: React.ReactNode
}

export const Notice = ({ message, variant = 'warning', title = 'Important note', children }: NoticeProps) => {
  return (
    <div
      className={cx(Styles.noticeContainer, {
        [Styles.warning]: variant === 'warning',
        [Styles.danger]: variant === 'danger',
      })}
    >
      <div className={Styles.title}>
        <AlertTriangle size={20} />
        <Heading level={5}>{title}</Heading>
      </div>
      {message}
      {children}
    </div>
  )
}
